import Box from '@mui/material/Box';
import { pxToRem } from '../../../utils/pxToRem';

export interface NavLinkProps {
  href: string;
  label: string;
  active?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export function NavLink({ href, label, active = false, onClick }: NavLinkProps) {
  return (
    <Box
      component="a"
      href={href}
      onClick={onClick}
      aria-current={active ? 'true' : undefined}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: pxToRem(8),
        paddingBlock: pxToRem(4),
        color: 'common.white',
        fontFamily: '"Roboto", sans-serif',
        fontSize: pxToRem(12),
        lineHeight: pxToRem(20),
        textDecoration: 'none',
        borderBottom: '2px solid transparent',
        transition: 'color 120ms ease, border-color 120ms ease',
        '&:hover': {
          color: 'secondary.main',
        },
        ...(active && {
          borderBottomColor: 'secondary.main',
        }),
      }}
    >
      {label}
    </Box>
  );
}
